import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import * as injection_constants from './injection-constants';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavigationModule } from './modules/navigation/navigation.module';
import { environment } from 'src/environments/environment';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { SectionConfigurationModule } from './modules/section-configuration/section-configuration.module';
import { MsalModule } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { MsalInterceptor } from '@azure/msal-angular';
import { ManagementModule } from './modules/management/management.module';
import { DeadLettersModule } from './modules/dead-letters/dead-letters.module';
import { AuthenticationRedirectComponent } from './authentication-redirect.component';

@NgModule({
  declarations: [
    AppComponent,
    AuthenticationRedirectComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NavigationModule,
    SectionConfigurationModule,
    ManagementModule,
    DeadLettersModule,
    HttpClientModule,
    TranslateModule.forRoot({
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: 'assets/i18n/',
        suffix: '.json'
      })
    }),
    MatToolbarModule,
    MatIconModule,
    MsalModule.forRoot(new PublicClientApplication({
      auth: {
        ...environment.adApp,
        postLogoutRedirectUri: environment.adApp.redirectUri
      },
      cache: {
        cacheLocation: 'localStorage'
      }
    }), {
      interactionType: InteractionType.Redirect, // MSAL Guard Configuration
      authRequest: {
        scopes: [environment.authScope]
      }}, {
        interactionType:InteractionType.Redirect,
        protectedResourceMap: new Map<string, Array<string> | null>([
          [`${environment.apiUrls.baseUrl}/*`,[environment.authScope]]
        ])})
  ],
  providers: [
    {
      provide: injection_constants.API_BASE_URL,
      useValue: environment.apiUrls.baseUrl,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent, AuthenticationRedirectComponent]
})
export class AppModule { }
